import React, { useState, useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

function TimeSeriesPlot({ serialNumber, stepped = false, tension = 0, onDataLoaded }) {
    const [data, setData] = useState([]);
    const [leftTime, setLeftTime] = useState('');   // State for start time
    const [rightTime, setRightTime] = useState(''); // State for end time
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const chartInstance = useRef(null);
    const canvasRef = useRef(null);

    // 1) Fetch data whenever leftTime or rightTime changes
    useEffect(() => {
        fetchData();
    }, [leftTime, rightTime, serialNumber]);

    // 2) The async fetch function
    const fetchData = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) throw new Error('No token found, user is not authenticated');

            const url =
                `${API_URL}/api/devices/time-series?serialNumber=${serialNumber}` +
                (leftTime ? `&leftTime=${new Date(leftTime).toISOString()}` : '') +
                (rightTime ? `&rightTime=${new Date(rightTime).toISOString()}` : '');

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`, // Attach the token
                },
            });
            //const response = await fetch(url);
            const result = await response.json();
            setData(result);
        } catch (error) {
            console.error("Error fetching time-series data:", error);
        }
    };

    // 3) Initialize or update the Chart.js instance whenever data changes
    useEffect(() => {
        if (data.length > 0) {
            if (!chartInstance.current) {
                const ctx = canvasRef.current.getContext('2d');
                chartInstance.current = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: data.map(item => new Date(item.timestamp).toLocaleString()),
                        datasets: [
                            {
                                label: 'Device Data',
                                data: data.map(item => parseFloat(item.data)),
                                borderColor: 'rgba(75, 192, 192, 1)',
                                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                                borderWidth: 1,
                                stepped: stepped,
                                tension: tension
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        scales: {
                            x: { title: { display: true, text: 'Time' } },
                            y: { title: { display: true, text: 'Value' } }
                        }
                    }
                });
            } else {
                // Update existing chart
                chartInstance.current.data.labels = data.map(item =>
                    new Date(item.timestamp).toLocaleString()
                );
                chartInstance.current.data.datasets[0].data = data.map(item =>
                    parseFloat(item.data)
                );
                chartInstance.current.data.datasets[0].stepped = stepped;
                chartInstance.current.data.datasets[0].tension = tension;

                chartInstance.current.update();
            }
        }
    }, [data, stepped, tension]);

    // 4) Передача загруженных данных родительскому компоненту через onDataLoaded
    useEffect(() => {
        if (onDataLoaded) {
            onDataLoaded(data);
        }
    }, [data, onDataLoaded]);

    return (
        <div style={{ textAlign: 'center' }}>
            {/* 1) Render the chart first */}
            <canvas ref={canvasRef} width="400" height="200" />

            {/* 2) Time pickers in a single row */}
            <div
                style={{
                    marginTop: '10px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '20px'
                }}
            >
                <label>
                    Start Time:
                    <input
                        type="datetime-local"
                        value={leftTime}
                        onChange={(e) => setLeftTime(e.target.value)}
                        style={{ marginLeft: '5px' }}
                    />
                </label>
                <label>
                    End Time:
                    <input
                        type="datetime-local"
                        value={rightTime}
                        onChange={(e) => setRightTime(e.target.value)}
                        style={{ marginLeft: '5px' }}
                    />
                </label>
            </div>
        </div>
    );
}

export default TimeSeriesPlot;
